import { api } from "./client";

/**
 * Интерфейс за един запис от data масива - данни по сервитьор и дата
 * Съдържа информация за сервитьор, дата и суми по различни методи на плащане
 */
/**
 * Сума/брой по метод на плащане — КАКТО Е ПЛАТЕНА сметката
 * (смесеното е собствен метод с пълната си сума)
 */
export interface WaiterMethodAmount {
  payment_method_id: number;
  amount: number;
  count: number;
}

export interface WaiterDataItem {
  waiterId: number;
  waiterName: string;
  date: string;
  cash_amount: number;
  card_amount: number;
  cash_count: number;
  card_count: number;
  mixed_count: number;
  /** Сметките с ненулева сума — знаменателят на „Средна сметка". */
  paid_count: number;
  total: number;
  methods: WaiterMethodAmount[];
}

/**
 * Интерфейс за summary запис - обобщени данни по сервитьор за целия период
 * Включва общи суми и бройки по метод на плащане
 */
export interface WaiterSummaryItem {
  waiterName: string;
  totalCash: number;
  totalCard: number;
  total: number;
  countCash: number;
  countCard: number;
  countMixed: number;
  /** Сметките с ненулева сума — знаменателят на „Средна сметка". */
  countPaid: number;
  methods: WaiterMethodAmount[];
}

/**
 * Отговор от API-то за справка по сервитьори
 * data - детайлни данни по дати за всеки сервитьор
 * summary - обобщение по сервитьор за целия период
 */
export interface WaiterReportResponse {
  data: WaiterDataItem[];
  summary: WaiterSummaryItem[];
}

/**
 * Филтри за заявката - start_date и end_date в ISO 8601 формат
 * Без параметри връща всички закрити сметки без ограничение по дата
 */
export interface WaiterReportFilters {
  start_date?: string;
  end_date?: string;
}

/**
 * Извлича справка по сервитьори от API-то
 * GET /reports/analytics/waiters
 * @param filters - опционални филтри за начална и крайна дата
 * @returns обект с data (по дати) и summary (обобщение по сервитьор)
 */
export const getWaitersReport = async (
  filters?: WaiterReportFilters,
): Promise<WaiterReportResponse> => {
  const params = new URLSearchParams();

  // Добавяме филтри за дати ако са подадени
  if (filters?.start_date) params.append("start_date", filters.start_date);
  if (filters?.end_date) params.append("end_date", filters.end_date);

  const queryString = params.toString();
  const url = `/reports/analytics/waiters${queryString ? `?${queryString}` : ""}`;

  const response = await api.get<WaiterReportResponse>(url);
  return response.data;
};
